module.exports = __webpack_public_path__ + "img/spkpr.89db45ed.png";